// export default {
//   en: require("./locales/en.json"),
//   ar: require("./locales/ar.json"),
//   zh: require("./locales/zh.json")
// };
import I18n from 'vue-i18n';
import Vue from 'vue';
Vue.use(I18n);
const i18n = new I18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    en: require('./locales/en.json'),
    zh: require('./locales/zh.json'),
    ar: require('./locales/ar.json'),
  },
});
export default i18n;
